import { message } from 'antd';
import { searchHubs } from 'src/api/VehicleRequest';
import { StylesProps } from 'src/library/types';
import { DeliveryRequestStyles } from './DeliveryAcknowledgement.styles';
import axios from 'axios';
import { uploadImages } from './DeliveryAcknowledgement.api';

export interface IDeliveryAcknowledgement {
  loader: boolean;
  consignments: any[];
  invoiceNumber: string;
  podList: [{ type?: string, url: string }];
  searchLoading: boolean;
  dropdownNumberList: string[];
  uploadLoading: boolean;
  selectedRowKeys: string[],
  filteredConsignments: any[],
  searchType: string;
  tripType: string;
}

export interface DeliveryRequestProps
  extends StylesProps<ReturnType<typeof DeliveryRequestStyles>> {
  deliveryAcknowledgement: IDeliveryAcknowledgement;
  getInvoiceConsignments: (data) => void;
  updateInvoicePODList: (data) => void;
  uploadFilesAndSave: (data) => void;
  fetchInvoiceNumbers: (data) => void;
  fetchISTInvoiceNumbers: (data) => void;
  setSelectedRowKeys: (data) => void;
  markCNsAsDelivered: (data?: {
    pieceLevelActions?: any;
    eventTime?: string;
    proof_image_list?: any;
  }) => void;
  markCNsAsDeliveredIST: () => void;
  markCNsAsUndelivered: (data) => void;
  markCNsAsUndeliveredIST: () => void;
  markCNsAsPickedUp: (data?: {
    pieceLevelActions?: any;
    eventTime?: string;
    proof_image_list?: any;
  }) => void;
  markCNsAsNotPickedUp: (data) => void;
  filterCnData: (data) => void;
  t: any;
  showPieceLevelActions: boolean;
  showVehicleRequestsMM: boolean;
  setTicketingToolVisibility: (data) => void;
  setTicketingToolURL: (data) => void;
  ticketingToolURL: string;
  orgData: any;
  consignmentActionConfig: any;
  vendorData: any;
  allFailureReasons?: any[];
  vendorConfig?: any;
}

export interface DeliveryRequestState {
  searchFilterQuery: string;
  isUploadPODModalVisible: boolean;
  isImageModalVisible: boolean;
  galleryImageData: string[];
  uploadPODFiles: any[];
  pdfUrl?: string;
  isPdfViewVisible: boolean;
  searchType: string;
  isEditPieceDetailsModalVisible?: boolean;
  selectedRowData: any;
  pieceActionList: any;
  actionType?: string;
  tripType: string;
  isReasonModalVisible?: boolean;
  reasonModalAction?: 'delivery' | 'pickup';
}

export const DeliveryConsignmentTripColumnList = [
  { column_id: 'reference_number', pretty_name: 'Reference Number' },
  { column_id: 'status', pretty_name: 'Status' },
  { column_id: 'flm_vendor_code', pretty_name: 'Vendor Code' },
  { column_id: 'is_partial_delivery', pretty_name: 'Partial Delivery' },
  { column_id: 'is_partial_pickedup', pretty_name: 'Partial Picked Up' },
  { column_id: 'worker_name', pretty_name: 'Rider Name' },
  { column_id: 'trip_organisation_reference_number', pretty_name: 'Trip Reference Number' },
  { column_id: 'vendor_image_url_list', pretty_name: 'Vendor POD Image' },
  { column_id: 'customer_pod', pretty_name: 'Customer POD Image' },
  { column_id: 'vehicle_number', pretty_name: 'Vehicle Number' },
  { column_id: 'courier_partner_reference_number', pretty_name: 'Carrier Reference Number' },
  { column_id: 'customer_name', pretty_name: 'Customer Name' },
  { column_id: 'destination_address', pretty_name: 'Destination Address' },
  { column_id: 'customer_category', pretty_name: 'Customer Category' },
  { column_id: 'customer_code', pretty_name: 'Customer Code' },
];

export const DeliveryConsignmentISTColumnList = [
  { column_id: 'reference_number', pretty_name: 'Reference Number' },
  { column_id: 'status', pretty_name: 'Status', width: 180 },
  { column_id: 'ist_vendor_code', pretty_name: 'Vendor Code' },
  { column_id: 'is_partial_delivery', pretty_name: 'Partial Delivery' },
  { column_id: 'is_partial_pickedup', pretty_name: 'Partial Picked Up' },
  { column_id: 'worker_name', pretty_name: 'Rider Name' },
  { column_id: 'middle_mile_trip_number', pretty_name: 'MM Trip Reference Number' },
  { column_id: 'vendor_image_url_list', pretty_name: 'Vendor POD Image' },
  { column_id: 'customer_pod', pretty_name: 'Customer POD Image' },
  { column_id: 'middle_mile_vehicle_number', pretty_name: 'Vehicle Number' },
  { column_id: 'courier_partner_reference_number', pretty_name: 'Carrier Reference Number' },
  { column_id: 'customer_name', pretty_name: 'Customer Name' },
  { column_id: 'destination_address', pretty_name: 'Destination Address' },
  { column_id: 'customer_category', pretty_name: 'Customer Category' },
  { column_id: 'customer_code', pretty_name: 'Customer Code' },
];

export const PieceDetailsColumnList = (actionType) => {
  return (
    [
      {
        pretty_name: 'S. No.',
        column_id: 'serial_number',
        width: 80,
      },
      {
        pretty_name: 'Reference Number',
        column_id: 'reference_number',
      },
      {
        pretty_name: 'Detail',
        column_id: 'description',
      },
      {
        pretty_name: 'Ordered Quantity',
        column_id: 'quantity',
      },
      {
        pretty_name: 'Weight(Kg)',
        column_id: 'weight',
      },
      {
        pretty_name: 'Volume',
        column_id: 'volume',
      },
      {
        pretty_name: 'Attempt Proof',
        column_id: 'attempt_proof',
      },
      {
        pretty_name: 'CN Verification',
        column_id: 'is_cnv_done',
      },
      {
        pretty_name: 'Amount to be Collected',
        column_id: 'cod_amount',
      },
      {
        pretty_name: 'Delivery Failure Reason',
        column_id: 'delivery_failure_reason',
      },
      {
        pretty_name: 'Pickup Failure Reason',
        column_id: 'pickup_failure_reason',
      },
      {
        pretty_name: 'Picked Quantity',
        column_id: 'quantity_pickedup',
        fixed: 'right',
        width: 150,
      },
      {
        pretty_name: 'Delivered Quantity',
        column_id: 'quantity_delivered',
        fixed: 'right',
        width: 150,
      },
      {
        pretty_name: 'Status',
        column_id: 'status',
        fixed: 'right',
        width: 400,
      },
      {
        pretty_name: 'POD',
        column_id: 'pod',
        fixed: 'right',
        width: 70,
      },
      {
        pretty_name: actionType === 'delivery' ? 'Delivery Timestamp' : 'Pickup Timestamp',
        column_id: 'event_timestamp',
        fixed: 'right',
        width: 240,
      },
    ]
  );
};

export const StatusOptions = {
  delivery: [
    { key: 'delivered', label: 'Delivered' },
    { key: 'attempted', label: 'Undelivered' },
  ],
  pickup: [
    { key: 'pickup_completed', label: 'Pick Completed' },
    { key: 'not_picked_up', label: 'Not Picked Up' },
  ],
};

export const BulkActionsMenu = (actionType) => {
  return (
    [
      {
        key: 'selected',
        label: 'Set selected as',
        children: [...(StatusOptions[actionType] || {})],
      },
    ]
  );
};

export const uploadPodFiles = async (podFiles: any) => {
  const signedUrlResponse = await uploadImages(podFiles);

  const promises = [];
  const urls = signedUrlResponse.data;

  for (let index = 0; index < podFiles.length; index += 1) {
    const file = podFiles[index];
    const { podSignedUrl } = urls[index];
    promises.push(
      axios.put(podSignedUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
      }),
    );
  }

  const result = await Promise.allSettled(promises);
  const failedUploads = [];

  const urlList = [];

  result.forEach(({ status }, idx) => {
    if (status === 'fulfilled') {
      urlList.push({
        type: podFiles[idx].type?.split('/')?.[1],
        url: urls[idx].podImageUrl,
      });
    } else {
      failedUploads.push(idx);
    }
  });

  if (failedUploads.length) {
    message.error('Some images failed to upload, please check and upload again');
  }

  return urlList;
};

export const PieceStatusOptions = {
  delivery: [
    { key: 'delivered', label: 'Delivered' },
    { key: 'attempted', label: 'Undelivered' },
  ],
  pickup: [
    { key: 'pickup_completed', label: 'Pick Completed' },
    { key: 'not_picked_up', label: 'Not Picked Up' },
  ],
};

export const isPODPresentForConsignments = (selectedRowKeys, consignments) => {
  const podPresentKeys = selectedRowKeys.filter((cnKey) =>
    consignments.some((cn) => cn.reference_number === cnKey && cn.vendor_image_url_list?.length));

  return Array.isArray(podPresentKeys) && podPresentKeys.length > 0 &&
    podPresentKeys.length === selectedRowKeys.length;
};

export const getFailureReasonList = (allFailureReasons, actionType) => {
  if (!Array.isArray(allFailureReasons) || !allFailureReasons.length) {
    return [];
  }
  if (actionType === 'delivery') {
    return allFailureReasons.filter((reason) => reason.is_ndr);
  }
  if (actionType === 'pickup') {
    return allFailureReasons.filter((reason) => reason.is_npr);
  }
  return [];
};
